var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('a-button-submit',{class:_vm.buttonClasses,attrs:{"type":"is-primary","loading":_vm.loading,"native-type":"submit"},on:{"click":function($event){return _vm.$emit('click')}}},[_vm._v(_vm._s(_vm.buttonText)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }